const Data = {
  updateLog: [
    {
      name: 'JavaScript SDK版本 5.3.747.1043',
      id: '46',
      time: '2026-09-04',
      list:
        '<div style="font-weight:bold;margin-top:15px">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">OBV6新增绘制路径添加深度测试，略微抬高z值防止共面路线显示不全；为流式模型实现正交视图功能；路径绘制功能添加虚线段样式；</li>' +
        '<li style="list-style-type: disc;">修复整模的restore接口无法恢复的问题；</li>' +
        '<li style="list-style-type: disc;">增加设置最大屏幕误差接口；</li>' +
        '<li style="list-style-type: disc;">提高低端移动设备内存上限；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">转换器</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">gim转换器：支持arm64架构；修复系列转换问题；</li>' +
        '<li style="list-style-type: disc;">rvt转换器：修复部分三角面丢失和异常问题；修复透明度问题；增加新的选择最佳视图的实现;</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本 5.3.741.1022',
      id: '46',
      time: '2026-08-07',
      list:
        '<div style="font-weight:bold;margin-top:15px">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">OBV6新增路径导航功能，可按第一/三人称沿着绘制路径漫游；</li>' +
        '<li style="list-style-type: disc;">OBV6新增五种预设主题；</li>' +
        '<li style="list-style-type: disc;">OBV6增加预设效果参数缓存功能；</li>' +
        '<li style="list-style-type: disc;">OBV6实现place3dModel方法，可通过鼠标动态放置模型；</li>' +
        '<li style="list-style-type: disc;">提升高端移动设备显示效果；</li>' +
        '<li style="list-style-type: disc;">修复水面与gis深度冲突闪烁问题；</li>' +
        '<li style="list-style-type: disc;">修复移动设备屏幕误差计算错误的问题；</li>' +
        '<li style="list-style-type: disc;">修复动画中瓦片被隐藏的问题；</li>' +
        '<li style="list-style-type: disc;">修复轴网交互线取消勾选不会消失的问题；</li>' +
        '<li style="list-style-type: disc;">修复开启GI后关闭不能再次打开的问题；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">转换器</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">gim转换器：新增样条曲线型式的电缆；修复瓦片生成失败，程序异常退出的问题；修复国网2023规范曲线电缆不完整创建的问题；弧线电缆由倒角弧线更改为圆弧线；修复国网2018规范倒圆角半径不显示的问题；</li>' +
        '<li style="list-style-type: disc;">dgn转换器：修复材质丢失、透明度丢失问题、中文及特殊符号乱码问题；</li>' +
        '<li style="list-style-type: disc;">pmodel转换器：修复draco选项不生效的问题；修复二维视图中文路径乱码的问题；</li>' +
        '<li style="list-style-type: disc;">rvt转换器：修复材质解析问题‘’修复贴图和属性解析丢失问题；</li>' +
        '<li style="list-style-type: disc;">fbx转换器：修复贴图绝对路径写入问题；</li>' +
        '<li style="list-style-type: disc;">ifc转换器：兼容部分IFC模型无模型树导出失败的问题;</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本 5.3.731.937',
      id: '46',
      time: '2026-03-06',
      list:
        '<div style="font-weight:bold;margin-top:15px">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">OBV6增加规范化读取扩展文件tilesets；</li>' +
        '<li style="list-style-type: disc;">修复OBV6瓦片异常情况重试机制bug，按需开启批量请求功能；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">转换器</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">ifc转换器：修复Linux转换崩溃问题；</li>' +
        '<li style="list-style-type: disc;">step转换器：修复分割 product 节点情况下三角面片折叠的问题；</li>' +
        '<li style="list-style-type: disc;">lod_ifc转换器：1.修复丢失构件的问题；2.修复透明度不对的问题；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本 5.3.731.936',
      id: '45',
      time: '2026-02-05',
      list:
        '<div style="font-weight:bold;margin-top:15px">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">修复线构件透明度不正确的问题；</li>' +
        '<li style="list-style-type: disc;">修复线构件选中错误问题；</li>' +
        '<li style="list-style-type: disc;">修复路径编辑不自动渲染的问题；</li>' +
        '<li style="list-style-type: disc;">修复背景色物理渲染切换问题；</li>' +
        '<li style="list-style-type: disc;">修复背景色透明度设置不生效的问题；</li>' +
        '<li style="list-style-type: disc;">修复空间树构件清除、选中接口无效问题；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">转换器</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">fbx转换器：优化转换性能；</li>' +
        '<li style="list-style-type: disc;">step转换器：修复叶子节点分割错误的问题；</li>' +
        '<li style="list-style-type: disc;">gltf转换器：修复draco压缩gltf模型转换失败的问题；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本 5.3.726.930',
      id: '44',
      time: '2026-01-12',
      list:
        '<div style="font-weight:bold;margin-top:15px">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">OBV6新增全时光照及镜头光晕效果；</li>' +
        '<li style="list-style-type: disc;">优化流式数据瓦片加载效率；</li>' +
        '<li style="list-style-type: disc;">优化mac设备以及高分屏渲染性能；</li>' +
        '<li style="list-style-type: disc;">修复部分空间节点无法显示问题；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">转换器</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">rvt转换器：支持导出模型组数据；修复部分模型过滤器颜色不正确问题；</li>' +
        '<li style="list-style-type: disc;">ifc转换器：支持拉伸体空间数据导出；将项目基点写入到属性中；</li>' +
        '<li style="list-style-type: disc;">fbx转换器：支持PBR贴图的导出和优化；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本 5.3.716.916',
      id: '43',
      time: '2025-12-11',
      list:
        '<div style="font-weight:bold;margin-top:15px">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增倾斜摄影压平功能支持设置负高度，实现挖洞效果；</li>' +
        '<li style="list-style-type: disc;">针对百万构件大体量模型优化性能热点、瓦片加载效率；</li>' +
        '<li style="list-style-type: disc;">优化塔吊动画中吊钩运动的平滑效果；</li>' +
        '<li style="list-style-type: disc;">修复频繁加载释放异常问题；</li>' +
        '<li style="list-style-type: disc;">兼容无法线数据的加载；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">国产自主</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">适配云渲染接口满足批注插件使用</li>' +
        '<li style="list-style-type: disc;">云渲染适配奇安信浏览器，兼容部分浏览器版本bug</li>' +
        '</ul>'+
        '<div style="font-weight:bold;margin-top:15px">转换器</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">rvt转换器：支持模型组、模型组属性导出；修复构件飞模、丢失问题；</li>' +
        '<li style="list-style-type: disc;">navisworks插件：修复构件飞模问题；</li>' +
        '</ul>'
    },{
      name: 'JavaScript SDK版本 5.3.705.898',
      id: '42',
      time: '2025-11-3',
      list:
        '<div style="font-weight:bold;margin-top:15px">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增全屏水印渲染接口，支持自定义水印效果；</li>' +
        '<li style="list-style-type: disc;">新增setObjectsSelectable接口,实现设置构件是否可选中；</li>' +
        '<li style="list-style-type: disc;">新增enableModelVisibilityCulling参数控制模型可见性判断</li>' +
        '<li style="list-style-type: disc;">更新OBV6版本,新增支持雨雪雾、GI接口</li>' +
        '<li style="list-style-type: disc;">修复若干三维模型问题，包含调用爆炸接口构件包围盒、材质选中、空间构件获取等</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">国产自主</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增二维图纸云渲染，实现加载、鼠标拖动、缩放及选中</li>' +
        '</ul>'+
        '<div style="font-weight:bold;margin-top:15px">转换器</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增rvm_lod转换器，支持linux:x86-64和linux:arm64</li>' +
        '<li style="list-style-type: disc;">优化rvt、ifc转换器，支持实例化瓦片拆分和粗略级别生成</li>' +
        '<li style="list-style-type: disc;">优化lod_fbx转换器，支持读取适配粗略级别实例化瓦片</li>' +
        '</ul>'+
        '<div style="font-weight:bold;margin-top:15px">示例代码</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增<a href="https://cloud.pkpm.cn/playground/lod/?sampleID=waterMark" target="_blank">水印渲染</a>、<a href="https://cloud.pkpm.cn/playground/lod/?sampleID=smooth" target="_blank">抹光机器人</a>、<a href="https://cloud.pkpm.cn/playground/lod/?sampleID=concreteSpreader" target="_blank">布料机</a>、<a href="https://cloud.pkpm.cn/playground/lod/?sampleID=elevator" target="_blank">施工电梯</a>示例</li>'+
        '</ul>'
    },{
      name: 'JavaScript SDK版本 5.3.698.891',
      id: '41',
      time: '2025-10-10',
      list:
        '<div style="font-weight:bold;margin-top:15px">三维模型</div>' +
          '<ul style="line-height:30px;margin-left:15px">' +
          '<li style="list-style-type: disc;">优化贴图按需加载，提高多贴图模型初次加载效率；</li>' +
          '<li style="list-style-type: disc;">修复动态标签、瓦片、边线等部分问题；</li>' +
          '<li style="list-style-type: disc;">修复skp转换器，部分贴图和透明度解析错误的问题，未正确解析图层隐藏状态的问题；</li>' +
          '<li style="list-style-type: disc;">修复pmodel转换器，部分模型复杂构件件飞模的问题；</li>' +
          '<li style="list-style-type: disc;">修复gim转换器，国网2023规范变电站模型透明度异常的问题；</li>' +
          '<li style="list-style-type: disc;">修复fbx转换器，部分模型法线变换错误的问题；</li>' +
          '</ul>' +
          '<div style="font-weight:bold;margin-top:15px">国产自主</div>' +
          '<ul style="line-height:30px;margin-left:15px">' +
          '<li style="list-style-type: disc;">云渲染增加电子围栏接口</li>' +
          '</ul>'
    },{
      name: 'JavaScript SDK版本 5.3.692.885',
      id: '40',
      time: '2025-09-05',
      list:
        '<div style="font-weight:bold;margin-top:15px">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">修复fbx_lod转换器基点误差、大坐标浮点误差，解决部分FBX模型坐标太大产生的误差；</li>' +
        '<li style="list-style-type: disc;">新增lod_fbx转换器按模型树层级拆分文件导出功能，支持大体量模型拆分导出为多个fbx文件；</li>' +
        '<li style="list-style-type: disc;">优化聚光灯角度，放宽至0-PI；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">国产信创</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">云渲染增加聚光灯、点光源、自发光相关接口；</li>' +
        '<li style="list-style-type: disc;">新增setBatchObjectsRangeColor接口，用于支持多构件二分段着色功能；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">示例代码</div>' +
            '<ul style="line-height:30px;margin-left:15px">' +
          '<li style="list-style-type: disc;">新增<a href="https://cloud.pkpm.cn/playground/lod/?sampleID=collision" target="_blank">动态碰撞检查</a>示例，支持运动中物体碰撞检测；</li>' +
        '</ul>'
    },{
      name: 'JavaScript SDK版本 5.3.677.865',
      id: '39',
      time: '2025-07-01',
      list:
        '<div style="font-weight:bold;margin-top:15px">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">动画系统升级，新增<a href="https://cloud.pkpm.cn/devcenter/help/js-api/docs/demo-api/docs/demo-api/#_23" target="_blank">物理引擎</a>，支持数据驱动的构件动画，可在示例代码“塔吊动画”中预览效果;</li>' +
        '<li style="list-style-type: disc;">发布OBV6.0 WebGPU版本;</li>' +
        '<li style="list-style-type: disc;">解决大体量合模场景下加载卡顿等问题，优化模型动态调度机制，加载效率可提升10%-300%，内存占用可降低10-20%，实现更多数量模型的流畅合模;</li>' +
        '<li style="list-style-type: disc;">新增<a href="https://cloud.pkpm.cn/devcenter/help/js-api/docs/demo-api/docs/demo-api/#_29">路径绘制</a>样式编辑接口，支持修改线宽颜色等;</li>' +
        '<li style="list-style-type: disc;">设置面板中添加模型数量统计信息。</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">国产信创</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">pdf-lod、modelmerge-lod转换器支持Linux arm64架构；</li>' +
        '<li style="list-style-type: disc;">发布国产自主可控云渲染的示例代码;</li>' +
        '<li style="list-style-type: disc;">修复pmodel_lod视图、rvt_lod基点精度、二维对比等若干问题。</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">示例代码</div>' +
          '<ul style="line-height:30px;margin-left:15px">' +
          '<li style="list-style-type: disc;"><a href="https://cloud.pkpm.cn/playground/lod?sampleID=loadWebRTC" target="_blank">云渲染</a>;</li>' +
          '<li style="list-style-type: disc;"><a href="https://cloud.pkpm.cn/playground/lod?sampleID=TowerCraneAnimation" target="_blank">塔吊动画</a>;</li>' +
        '</ul>'
    },{
      name: 'JavaScript SDK版本 5.3.665.856',
      id: '38',
      time: '2025-06-06',
      list:
        '<div style="font-weight:bold;margin-top:15px">国产信创</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">发布国产自主可控云渲染，增加角度、面积、体积测量等功能;</li>' +
        '<li style="list-style-type: disc;">优化多次切换端云渲染通信，云渲染断连后重新连接逻辑;</li>' +
        '<li style="list-style-type: disc;">修复云渲染长时间误操作时推流挂起问题;</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">转换器</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">rvt转换器：修复部分模型造型问题，部分空模型转换失败问题;</li>' +
        '<li style="list-style-type: disc;">pmodel_lod转换器：修复空视图、扩展文件空路径崩溃等问题;</li>' +
        '</ul>'+
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">修复二维图纸中图层名称一致性问题\n</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本 5.3.655.847',
      id: '37',
      time: '2025-05-12',
      list:
        '<div style="font-weight:bold;margin-top:15px">国产信创</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">发布国产自主可控云渲染，支持信创操作系统、国产CPU和GPU，降低终端电脑和移动设备的硬件要求；</li>' +
        '<li style="list-style-type: disc;">发布OBV6版本技术预览版，支持 WebGPU，渲染帧率提高2倍；</li>' +
        '<li style="list-style-type: disc;">优化dwg、dgn、nwd、点云las转换器，支持国产信创arm架构；</li>' +
        '<li style="list-style-type: disc;">优化pTiles SDK，支持pModel读取，大幅降低pmodel-lod转换时间，转换平均效率提升100%+；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">效率优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">优化模型树面板节点状态更新效率，针对10w+构件级别的模型，面板交互流畅度大幅提升；</li>' +
        '</ul>'+
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">效率优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">修复若干渲染与转换器问题，优化fbx转换贴图、端/云渲染切换效果等。</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本 5.3.632.830',
      id: '36',
      time: '2025-03-31',
      list:
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">ifc转换器：空模型会转换失败；兼容构件ID异常的模型转换；</li>' +
        '<li style="list-style-type: disc;">RVT转换器：修复族文件获取部分参数异常的问题；</li>' +
        '<li style="list-style-type: disc;">FBX转换器：修复部分模型透明度获取异常问题；兼容部分模型构件ID不唯一的模型转换；</li>' +
        '<li style="list-style-type: disc;">GIM转换器：修复部分架空线路绝缘子串、防震锤、间隔棒飞出的问题；修复绝缘子串造型问题；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">渲染效果</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增天空大气效果、昼夜交替效果、lensflare效果，新增<a href="../../../../playground/lod?sampleID=bloom" target="_blank">动态天空盒</a>示例代码</a>，支持为材质配置自发光强度，模拟光源的扩散现象；</li>' +
        '<li style="list-style-type: disc;">OBV5云渲染增加多实例调度适配请求</li>' +
        '<li style="list-style-type: disc;">修复bloom效果未开启时，设置BloomThreshold报错的问题</li>' +
        '<li style="list-style-type: disc;">修复AR模式下，相机实景异常问题</li>' +
        '<li style="list-style-type: disc;">修复未加载模型前释放obv时shadow报错问题</li>' +
        '<li style="list-style-type: disc;">修复设置背景色透明度失效的问题</li>' +
        '<li style="list-style-type: disc;">优化夜景地平线渐变</li>' +
        '</ul>'
    },{
      name: 'JavaScript SDK版本 5.3.620.818',
      id: '35',
      time: '2025-02-28',
      list:
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">IFC转换器：修复空模型转换失败问题；兼容构件ID异常模型转换失败问题；</li>' +
        '<li style="list-style-type: disc;">RVT转换器：修复族文件获取部分参数异常的问题；</li>' +
        '<li style="list-style-type: disc;">FBX转换器：修复部分模型透明度获取异常问题；兼容部分模型构件ID不唯一转换失败问题；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本 5.3.618.816',
      id: '34',
      time: '2025-01-22',
      list:
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">DGN转换器：修复部分模型的几何造型问题；</li>' +
        '<li style="list-style-type: disc;">RVT转换器：修复部分嵌套构件的实例化问题；</li>' +
        '<li style="list-style-type: disc;">FBX转换器：修复基点旋转角计算错误问题；增加详细导出日志；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">渲染效果</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增<a href="../../../../playground/lod?sampleID=bloom" target="_blank">Bloom效果</a>，支持为材质配置自发光强度，模拟光源的扩散现象；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本 5.3.611.809',
      id: '33',
      time: '2024-12-03',
      list:
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">RVT转换器：支持钢筋的实例化导出，提高转换效率；优化属性导出；</li>' +
        '<li style="list-style-type: disc;">NWD转换器：新版转换器上线，进一步提高转换效率和质量；</li>' +
        '<li style="list-style-type: disc;">DGN转换器：修复部分模型几何造型异常的问题；</li>' +
        '<li style="list-style-type: disc;">FBX转换器：兼容部分模型转换异常的问题；</li>' +
        '<li style="list-style-type: disc;">OSGB转换器：优化大模型内存占用；兼容空文件转换异常的问题；</li>' +
        '<li style="list-style-type: disc;">GIM转换器：优化南网规范模型适配；</li>' +
        '<li style="list-style-type: disc;">LAS转换器：优化大模型内存占用；</li>' +
        '<li style="list-style-type: disc;">DWG转换器：优化部分字体显示样式；</li>' +
        '<li style="list-style-type: disc;">模型加载新增<a href="../../../../devcenter/help//js-api/docs/demo-api/docs/demo-api/#unloadmodel" target="_blank">卸载指定模型接口</a>，满足不同场景下模型管理需求；</li>' +
        '<li style="list-style-type: disc;">流式合模新增<a href="../../../../devcenter/help//js-api/docs/demo-api/docs/demo-api/#v3dlodloadedendevent" target="_blank">监听流式数据场景初始化加载完成事件，避免因数据未加载完成而导致的延迟或错误，减轻二开用户手动管理数据状态成本</a>；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">渲染效果</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增<a href="../../../../playground/lod?sampleID=pointLight" target="_blank">点光源特效</a>，支持点光源亮度、颜色等参数调整,能够创造出丰富的光影层次，增强画面的立体感和深度‌；</li>' +
        '<li style="list-style-type: disc;"><a href="../../../../playground/lod?sampleID=pointLight" target="_blank">轮廓辉光特效</a>新增深度遮挡计算，提升渲染效果的真实感和视觉深度；</li>' +
        '<li style="list-style-type: disc;"><a href="../../../../playground/lod?sampleID=modelMarking" target="_blank">Marker插件</a>新增添加图片锚点示例，支持自由调整图片位置、大小，满足多样化的设计需求；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.603.801',
      id: '32',
      time: '2024-12-06',
      list:
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增DGN转换器对附加贴图文件的支持，提升模型视觉效果的一致性；新增deviation参数，允许用户调整剖分精度，以满足不同应用场景对模型细节的需求；优化模型基点数据获取方式，优先从ACS系统中获取，确保模型定位的准确性；</li>' +
        '<li style="list-style-type: disc;">新增NWD转换器支持嵌入式贴图解析功能；提升NWD转换器对文件属性和文件贴图解析效率，增强用户体验；</li>' +
        '<li style="list-style-type: disc;">解决IFC转换器内置贴图解析错误问题，确保贴图在转换过程中正确应用，提升模型质量；解决未偏移基点问题，确保模型位置信息的准确性；</li>' +
        '<li style="list-style-type: disc;">解决FBX转换器基点未进行轴向转换问题，确保模型在不同坐标系下的正确显示和定位；</li>' +
        '<li style="list-style-type: disc;">解决GIM质检工具自动判别绝缘子串专业错误问题，提高质检的准确性和可靠性；</li>' +
        '<li style="list-style-type: disc;">提升模型对比结果解析能力，助力用户快速识别模型差异；</li>' +
        '<li style="list-style-type: disc;">优化GIM转换器对不规范STL绝缘子串的解析处理，提升格式解析质量；优化日志输出，使问题追踪和调试更加高效；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.595.789',
      id: '31',
      time: '2024-11-06',
      list:
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">解决RVT转换器过滤器中构件材质错误的问题，确保材质信息准确转换；</li>' +
        '<li style="list-style-type: disc;">提升GIM转换器转换效率，增强用户体验；</li>' +
        '</ul>'+
        '<div style="font-weight:bold;margin-top:15px">三维编辑</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增<a href="../../../../devcenter/help//js-api/docs/demo-api/docs/demo-api/#v3dgeometrydrawenscape" target="_blank">结束轮廓绘制与结束二次编辑的监听事件</a>，提升用户交互体验；</li>' +
        '<li style="list-style-type: disc;">新增<a href="../../../../devcenter/help//js-api/docs/demo-api/docs/demo-api/#v3dpolylinedrawenscape" target="_blank">结束路径绘制与结束编辑的监听事件</a>，增强路径操作的灵活性；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.584.780',
      id: '30',
      time: '2024-10-14',
      list:
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">插件支持Revit2023、2024版本的PModel模型导出。解决部分模型导出PModel的材质偏差问题，提升模型材质的准确性；</li>' +
        '<li style="list-style-type: disc;">转换日志中新增文件转化失败的详细信息，便于查询文件转换失败的原因；</li>' +
        '<li style="list-style-type: disc;">提升FBX格式转换质量，修复阴影的异常，提升金属材质效果，支持nurbs曲面构件导出等，确保模型转换的高准确度；</li>' +
        '<li style="list-style-type: disc;">Revit插件支持导出属性单位，便于属性数据的直观展示与友好利用；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">渲染效果</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增<a href="../../../../playground/lod?sampleID=dynamicFence" target="_blank">电子围栏特效</a>，支撑数字孪生等场景中的科技感表现，提升视觉体验；</li>' +
        '<li style="list-style-type: disc;">新增<a href="../../../../playground/lod?sampleID=createWater" target="_blank">水面特效</a>，支持模拟泳池、河流、海面等水域场景，让模型的场景环境更加生动和逼真；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.575.768',
      id: '29',
      time: '2024-09-09',
      list:
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">DWG图纸字体效率优化，减少图纸轻量化转换等待时间；</li>' +
        '<li style="list-style-type: disc;">优化PropSDK属性读取效率，大大降低应用侧属性解析转换和入库BIMS的时间，提升数据的处理效率；</li>' +
        '<li style="list-style-type: disc;">优化NWD模型坐标值的计算方法，解决NWD解决模型实际地理坐标过大时造的模型构件精度丢失，从而导致的模型闪烁等问题；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">渲染效果</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">增加<a href="../../../../playground/lod?sampleID=glowLine" target="_blank">轮廓辉光特效</a>，支持辉光效果亮度、颜色等参数调整,使物体在画面中更加突出醒目，满足大屏、汇报等应用场景；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">数据导出</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">优化3ds Max、 Blender等软件中导出FBX模型的物理材质参数，提高模型的真实感和观赏性；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.567.762',
      id: '28',
      time: '2024-08-08',
      list:
        '<div style="font-weight:bold;margin-top:15px">渲染效果</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">使用HDR（High Dynamic Range，高动态范围）技术，更准确地捕捉从阳光直射到最暗阴影的广泛亮度范围，使模型更加立体，获得更真实的视觉效果；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">优化dwg文件中字体效率，提升解析效率,减少等待时间；</li>' +
        '<li style="list-style-type: disc;">实现att文件的轻量化浏览和处理，以满足业务中对att文件浏览和管理的需求；</li>' +
        '<li style="list-style-type: disc;">增加IFC/RVT转换器中控制空间与数据分离的的参数，可根据需要选择是否导出空间数据；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.551.747',
      id: '27',
      time: '2024-07-05',
      list:
        '<div style="font-weight:bold;margin-top:15px">渲染效果</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">优化边线抗锯齿效果，大程度降低边线的虚线效果，模型的边缘更加清晰和平滑，提升视觉体验；</li>' +
        '<img style="width:600px; height: 100%" src="../../../../static/img/updateLogs/optimized-edge-anti-aliasing.png">' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">支持划分Revit模型树层次，模型按楼层分类后，区分建筑、结构电气、机械内容。可以更直观地了解模型的结构和内容，更快速地定位和理解模型中的各个部分；</li>' +
        '<li style="list-style-type: disc;">RVT转换器修复带洞口的空间造型问题，确保空间造型准确性和一致性，为后续的设计、分析和协作提供更可靠的基础；</li>' +
        '<li style="list-style-type: disc;">PtilesSDK数据导出坐标系数据精度提升，可以更精准地表示和记录空间位置信息；坐标系扩展增加angleToTrueNorth概念和字段，可以更准确地描述和处理项目中的方向性要求；</li>' +
        '<li style="list-style-type: disc;">3ds Max转换插件适配20-24版本软件，支持高版本3ds Max软件中导出Pmodel模型，支撑发电业务方案设计阶段模型的应用；</li>' +
        '<li style="list-style-type: disc;">GIM转换器适配南方电网规范，确保在行标规范中的数据一致性，提高数据质量和准确性；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.538.731',
      id: '26',
      time: '2024-06-05',
      list:
        '<div style="font-weight:bold;margin-top:15px">兼容适配</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">碰撞检查功能适配linux操作系统，提升功能的兼容性和灵活性；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">数据轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">实现PDMS软件中导出的rvm模型及属性文件的挂载转换，支撑发电业务应用；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">三维动画</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">针对选中模型根节点添加的平移、旋转、缩放动画的效率进行优化，提升动画播放的流畅度；</li>' +
        '<li style="list-style-type: disc;">解决同时添加多条显隐/透明/闪烁/剖切动画时起播时间长问题，实现即点即播的体验；</li>' +
        '<li style="list-style-type: disc;">修复路径动画中阴影跟随状态，解决构件变换方向时阴影方向不变化的问题；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.532.724',
      id: '25',
      time: '2024-05-07',
      list:
        '<div style="font-weight:bold;margin-top:15px">三维编辑</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增<a href="../../../../devcenter/help//js-api/docs/demo-api/docs/demo-api/#setlinecolor" target="_blank">轮廓编辑支持颜色参数的调整接口</a>，可根据需求调整绘制中边线与面的颜色；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">支持rvm、stp、step、stl格式文件的流式解析，支撑发电业务中所需格式模型轻量化转换；</li>' +
        '<li style="list-style-type: disc;">支持nwd/rvt线类型构件导出，提升模型导出的精细程度；</li>' +
        '<li style="list-style-type: disc;">修复无构件视图的转换报错问题，无构件视图可成功转换并浏览；</li>' +
        '<li style="list-style-type: disc;">以扩展的形式导出空间数据，IFC格式文件空间和构件分离，支撑IFC格式模型轻量化后的空间数据应用；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">模型质检</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">GIM质检支持部件属性质检，实现电网业务中对于部件的属性检查；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">示例和文档</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增<a href="../../../../playground/lod?sampleID=sceneEdit" target="_blank">场景编辑功能模型示例</a>与<a href="../../../../devcenter/help/js-api/docs/scene-edit/docs/scene-edit/" target="_blank">开发文档</a>；</li>' +
        '<li style="list-style-type: disc;">新增<a href="../../../../devcenter/help/js-api/docs/collision-check/docs/collision-check/" target="_blank">碰撞检查功能开发文档</a>；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.525.712',
      id: '24',
      time: '2024-04-08',
      list:
        '<div style="font-weight:bold;margin-top:15px">应用工具</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增选中构件后，以<a href="../../../../devcenter/help/js-api/docs/demo-api/docs/demo-api/#rotatearoundselection" target="_blank">构件中心为旋转基点</a>接口，丰富模型交互方式；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">显示效果</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">优化阴影显示，降低阴影锯齿效果，提升模型显示效果；</li>' +
        '<img style="width:600px; height: 100%" src="../../../../static/img/updateLogs/shadow.jpg">' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">以扩展的形式导出空间数据，实现RVT格式文件空间和构件的分离；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">开发文档</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增<a href="../../../../devcenter/help/js-api/docs/addin-api/docs/addin-api/#_5" target="_blank">模型衬图</a>功能的开发文档；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">常见问题</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增基本概念<a href="../../../../devcenter/commonQuestion/#1-1&8" target="_blank">OBV坐标系</a>；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.515.696',
      id: '23',
      time: '2024-03-01',
      list:
        '<div style="font-weight:bold;margin-top:15px">效果展示</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">丰富构件选中状态效果，支持构件选中时，不混合选中颜色；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">图模轻量化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">支持图纸的多视图转换，实现图纸内的模型和所有布局展示与切换；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.461.688',
      id: '22',
      time: '2024-02-04',
      list:
        '<div style="font-weight:bold;margin-top:15px">效果展示</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">优化模型边线显示效果，减少模型浏览过程中的边线锯齿效果；</li>' +
        '<li style="list-style-type: disc;">优化环境光遮蔽效果，提升模型显示的真实感；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">应用工具</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增构件间最短测量功能，提升模型测量效率；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">三维编辑</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增轮廓编辑能力，可在模型场景中绘制与编辑线、面、体；</li>' +
        '<li style="list-style-type: disc;">新增路径绘制功能，可绘制物体运动路径；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.448.675',
      id: '21',
      time: '2024-01-10',
      list:
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增多级、多层点云数据渲染能力，实现<a href="../../../../playground/lod?sampleID=loadPntsTileset" target="_blank">点云数据的轻量化浏览</a>；</li>' +
        '<li style="list-style-type: disc;">新增空间树节点多选功能，提升空间选择的便利性；</li>' +
        '<li style="list-style-type: disc;">新增<a href="../../../../devcenter/help/js-api/docs/demo-api/docs/demo-api/#setspaceroomconfig" target="_blank">预置构件、空间样式接口</a>，支持轮廓线高亮颜色调整，可根据实际需求进行颜色配置；</li>' +
        '<li style="list-style-type: disc;">优化图模视窗中工具面板的显示顺序，提升操作的便捷性；</li>' +
        '<li style="list-style-type: disc;">完成pmodel-lod空间树前端适配，实现pmodel格式模型在流式转换下的空间树展示；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.430.647',
      id: '20',
      time: '2023-12-11',
      list:
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增第三人称漫游功能，丰富模型浏览方式，实现沉浸式模型浏览；</li>' +
        '<img style="width:600px; height: 100%" src="../../../../static/img/updateLogs/third-person.png">' +
        '<li style="list-style-type: disc;">新增小地图功能，实现在漫游与模型浏览模式下实时定位与调整相机位置与角度；</li>' +
        '<li style="list-style-type: disc;">新增路径与流动效果动画，丰富动画类型，实现更加逼真的场景演示；</li>' +
        '<li style="list-style-type: disc;">新增模型树设置新数据、按照新模型树数据展示模型接口，支撑业务应用中对于模型树的二次编辑；</li>' +
        '<li style="list-style-type: disc;">新增对空间名称字体大小整体调整接口，可根据业务需求调整空间字体显示大小；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">插件更新</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增压平插件，支持倾斜摄影的平整和挖洞效果；</li>' +
        '</ul>'
    },
    {
      name: 'JavaScript SDK版本5.3.411.630',
      id: '19',
      time: '2023-11-10',
      list:
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增<a href="../../../../devcenter/help/js-api/docs/demo-api/docs/demo-api/#getshown" target="_blank">获取模型树当前隐藏和显示节点状态接口</a>，便于获取不同状态节点信息，便于模型节点状态和业务信息关联；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">环境渲染</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增晴天、阴天等天空盒背景，丰富模型环境展示效果；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">兼容适配</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">对搜狗浏览器进行适配，确保平台在搜狗浏览器上正常运行；</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.394.167',
      id: '18',
      time: '2023-10-10',
      list:
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增三维批注增颜色与线型粗细的接口，支持自定义调整批注颜色、大小；</li>' +
        '<li style="list-style-type: disc;">优化模型闪烁效果，解决项目模型闪烁问题；</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">矢量图纸</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增图纸拆分功能的<a href="../../../../playground/lod?sampleID=drawSplitting" target="_blank">示例代码</a>与<a href="../../../../devcenter/help/server-api/docs/Translation/#_11" target="_blank">开发文档</a>，支持按图框拆出单张图纸，并定位与预览；</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.381.605',
      id: '18',
      time: '2023-09-11',
      list:
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增<a href="../../../../devcenter/help/js-api/docs/demo-api/docs/demo-api/#restorehomeviewpoint" target="_blank">主视图设置</a>功能，支持对模型与合模进行自定义主视角图与重置主视图；</li>' +
        '<img style="width:600px; height: 100%" src="../../../../static/img/updateLogs/restoreHomeViewPoint.jpg">' +
        '<li style="list-style-type: disc;">优化dgn/gim数据解析处理算法，优化提升数据质量和加载效果；</li>' +
        '<li style="list-style-type: disc;">优化<a href="../../../../devcenter/help/js-api/docs/addin-api/docs/addin-api/#marker" target="_blank">Marker插件</a>开发文档；</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.368.568',
      id: '17',
      time: '2023-08-09',
      list:
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">优化模型框选、增加测量多段线MeasureFinished事件；</li>' +
        '<li style="list-style-type: disc;">优化提升动画播放性能，提升动画效果稳定性；</li>' +
        '<li style="list-style-type: disc;">优化提升dgn格式效果，包括大场景模型、贴图等效果；</li>' +
        '<li style="list-style-type: disc;">优化代码示例中<a href="../../../../playground/lod?sampleID=translateAnimation" target="_blank">动画</a>等能力展示效果，方便开发用户参照；</li>' +
        '<li style="list-style-type: disc;">修复若干流式模型视图与模型对比的问题；</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.360.552',
      id: '16',
      time: '2023-07-05',
      list:
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc">优化<a href="../../../../playground/lod?sampleID=obvPlugIn" target="_blank">三维测量</a>工具捕捉效率与结果展示形式；</li>' +
        '<img style="width:600px; height: 100%" src="../../../../static/img/updateLogs/measure.jpg">' +
        '<li style="list-style-type: disc;">优化特殊构件显示效果，提升小体积复杂的构件（如围栏等）模型浏览流畅度；</li>' +
        '<li style="list-style-type: disc;">优化大场景模型加载效率效果；</li>' +
        '<li style="list-style-type: disc;">优化模型空间树层级解析；</li>' +
        '<li style="list-style-type: disc;">优化代码示例中部分能力展示效果，方便开发用户参照；</li>' +
        '<li style="list-style-type: disc;">修复相机近裁剪问题，提升测量等功能使用体验。</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.339.474',
      id: '15',
      time: '2023-06-05',
      list:
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc">新增<a href="../../../../playground/lod?sampleID=setModelHomeView" target="_blank">自定义主视图主视角</a>接口，支持用户根据需要设置模型加载的默认主视图的视角；<img style="width:45px; height: 45px" src="../../../../static/img/updateLogs/modelHomeViewIcom.png"></li>' +
        '<li style="list-style-type:disc">新增<a href="../../../../devcenter/help/server-api/docs/Translation/#11" target="_blank">查询转换日志接口</a>、<a href="../../../../devcenter/help/server-api/docs/Translation/#12" target="_blank">查询转换进度接口</a>以及<a href="../../../../devcenter/help/server-api/docs/Translation/#gim" target="_blank">GIM检查功能接口</a>；</li>' +
        '<li style="list-style-type: disc;">优化模型缓存设置，改为默认开启缓存；</li>' +
        '<li style="list-style-type: disc;">修复若干模型显示效果与效率问题</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">矢量图纸</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">新增<a href="../../../../playground/lod?sampleID=load2DModel" target="_blank">图纸测量工具</a>，支持测量线段长度、角度与面积；</li>' +
        '<img style="width:300px; height: 220px" src="../../../../static/img/updateLogs/2dMeasure.png">' +
        '<li style="list-style-type: disc;">新增<a href="../../../../playground/lod?sampleID=setLayerColor" target="_blank">图纸颜色设置</a>接口，支持修改图纸中的图层与图元颜色；</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.329.463',
      id: '14',
      time: '2023-04-28',
      list:
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc">优化构件边线透明度设置，当构件颜色或透明度变化时，构件边线保持统一</li>' +
        '<li style="list-style-type: disc;">优化地图背景（GIS）在缩放/动画等浏览中的显示流畅度；</li>' +
        '<li style="list-style-type: disc;">优化模型抗锯齿效果与效率选项，提高栅格等密集构件显示精确度与性能平衡，具体选项说明见<a href="../../../../devcenter/commonQuestion#2-1&11" target="_blank">常见问题</a></li>' +
        '<img style="width:600px; height: 100%" src="../../../../static/img/updateLogs/anti-aliasing.png">' +
        '<li style="list-style-type: disc;">优化模型边线效果，提升模型构件显示的清晰度与层次感；</li>' +
        '<img style="width:600px; height: 100%" src="../../../../static/img/updateLogs/side-line.png">' +
        '<li style="list-style-type: disc;">提升pmodel/rvt/ifc格式轻量化数据质量，提高渲染效率；提升gim/p3d大模型转换稳定性；修复部分fbx文件转换速度慢的问题；</li>' +
        '<li style="list-style-type: disc;">优化环境背景图，设置-渲染-环境背景增加纯色天空盒贴图；</li>' +
        '<img style="width:600px; height: 100%" src="../../../../static/img/updateLogs/solid-color-sky-box.png">' +
        '<li style="list-style-type: disc;">修复倾斜摄影数据解析若干问题。</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.315.454',
      id: '13',
      time: '2023-04-11',
      list:
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc">优化构件分段着色效果，支持对构件设置分段显隐</li>' +
        '<li style="list-style-type: disc;">优化<a href="../../../../devcenter/help/development-guide/docs/upload-model/docs/development-guide/#_8" target="_blank">倾斜摄影</a>效率，优化数据转换、解析加载、缓存加速等，提高转换成功率和数据质量。</li>' +
        '<li style="list-style-type: disc;">优化倾斜摄影与GIS底图融合效果。</li>' +
        '<img style="width:300px; height: 220px" src="../../../../static/img/updateLogs/osgb-gis.png">' +
        '<li style="list-style-type: disc;">优化移动端三维标签点击交互效果。</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">矢量图纸</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type: disc;">优化<a href="../../../../devcenter/help/js-api/docs/2d/docs/2d-api/" target="_blank">二维图纸</a>效率：全面升级矢量二维的底层数据转换服务和前端展示。优化二三维联动功能。</li>' +
        '<li style="list-style-type: disc;">优化二维图纸主体内容自适应，避免远处多余构件影响图纸主视图。</li>' +
        '<img style="width:300px; height: 220px" src="../../../../static/img/updateLogs/2dOptimization-1.png">' +
        '<img style="width:300px; height: 220px" src="../../../../static/img/updateLogs/2dOptimization-2.png">' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.284.423',
      id: '12',
      time: '2023-03-02',
      list:
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc">优化流式加载数据请求，降低大模型初次加载耗时</li>' +
        '<li style="list-style-type: disc;">优化部分主流格式（rvt/gim/pmodel/ifc）流式加载下模型<a href="../../../../playground/lod/?sampleID=load3DModel" target="_blank">轮廓线显示</a>效果，提升模型层次感，支持在设置中显示/隐藏轮廓线</li>' +
        '<img style="width:300px; height: 220px" src="../../../../static/img/updateLogs/before-contour-optimization.png">' +
        '<img style="width:300px; height: 220px" src="../../../../static/img/updateLogs/after-contour-optimization.png">' +
        '<li style="list-style-type: disc;">优化漫游，支持在透视视角下，从当前视窗视角进入和退出漫游</li>' +
        '<li style="list-style-type: disc;">优化流式性能模式动态调度，取消设置面板手动调整流式性能模式选项，支持根据硬件性能动态调度自行开启</li>' +
        '<li style="list-style-type: disc;">优化模型<a href="../../../../playground/lod?sampleID=modelComparison" target="_blank">版本对比</a>删除构件交互，支持选中已删除构件，聚焦并查看已删除构件属性等操作</li>' +
        '<img style="width:300px; height: 220px" src="../../../../static/img/updateLogs/modelComparison.png">' +
        '<li style="list-style-type: disc;">优化加载兼容，支持webp兼容加载</li>' +
        '<li style="list-style-type: disc;">优化了若干体验问题，提升平台效率和稳定性，包括skybox、动画、渲染、旋转、大模型选中等</li>' +
        '<li style="list-style-type: disc;"><a href="https://www.pkpm.cn/product/download/downloadDetail?id=440" target="_blank">Revit轻量化插件</a>（V2.7.4.18）支持导出模型线</li>' +
        '<img style="width:300px; height: 220px" src="../../../../static/img/updateLogs/exporting-model-lines.png">' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.279.420',
      id: '11',
      time: '2023-02-07',
      list:
        '<div style="font-weight:bold">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc; margin-top:5px">新增流式模型<a href="../../../../playground/lod/?sampleID=obvPlugIn" target="_blank">测量捕捉</a>功能,流式模型测量时，可对端点、边线、面进行自动捕捉，提高测量精准度</li>' +
        '<img style="width:188px; height: 220px" src="../../../../static/img/updateLogs/measure-capture-1.png">' +
        '<img style="width:188px; height: 220px" src="../../../../static/img/updateLogs/measure-capture-2.png">' +
        '<img style="width:188px; height: 220px" src="../../../../static/img/updateLogs/measure-capture-3.png">' +
        '<img style="width:188px; height: 220px" src="../../../../static/img/updateLogs/measure-capture-4.png">' +
        '<img style="width:188px; height: 220px" src="../../../../static/img/updateLogs/measure-capture-5.png">' +
        '<li style="list-style-type:disc">新增<a href="../../../../devcenter/help/server-api/docs/3dTiles-api/#obv-3dtiles" target="_blank">3dTiles数据服务</a>开发文档</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">矢量图纸</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc">新增<a href="../../../../devcenter/help/js-api/docs/2d/docs/2d-api/#obvapisetbackgroundcolor" target="_blank">矢量图纸显示模式切换</a>接口，支持改变图纸底色为黑色或白色</li>' +
        '<img style="" src="../../../../static/img/updateLogs/setBackgroundColor.png">' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">优化<a href="../../../../devcenter/help/js-api/docs/demo-api/docs/demo-api/#v3dshowallevent" target="_blank">显隐隔离</a>相关事件</li>' +
        '<img style="" src="../../../../static/img/updateLogs/v3dshowallevent.png">' +
        '<li style="list-style-type:disc">优化<a href="../../../../devcenter/help/js-api/docs/demo-api/docs/demo-api/#v3dclipoffevent" target="_blank">开启/关闭剖切</a>事件</li>' +
        '<img style="" src="../../../../static/img/updateLogs/v3dclipoffevent.png">' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">修复嵌套worker不会释放的问题</li>' +
        '<li style="list-style-type: disc;">修复IOS低版本提示createImageBitmap错误问题</li>' +
        '<li style="list-style-type: disc;">修复流式贴图重复加载的问题</li>' +
        '<li style="list-style-type: disc;">修复截图导致模型树触发多选的问题</li>' +
        '<li style="list-style-type: disc;">修复LOD选中父节点设置动画失效的问题</li>' +
        '<li style="list-style-type: disc;">修复IOS端环境光阴影问题</li>' +
        '<li style="list-style-type: disc;">修复全量构件动画位置恢复后选中框线偏移的问题</li>' +
        '<li style="list-style-type: disc;">修复动画流式边线数据无法恢复位置的问题</li>' +
        '<li style="list-style-type: disc;">修复流式线构件动画恢复位置不正确的问题</li>' +
        '<li style="list-style-type: disc;">修复全量模型获取可见构件接口问题</li>' +
        '<li style="list-style-type: disc;">修复全量模型因线数据更新导致剖切接口报错问题</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.98.96',
      id: '10',
      time: '2022-03-04',
      list:
        '<div style="font-weight:bold">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">新增接口用于计算指定三维点垂向相交的模型坐标点，用于人员定位功能</li>' +
        '<li style="list-style-type:disc">LOD数据支持多材质线数据展示</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">优化getMergeInfo接口，针对合并模型信息查询若参数dbid参数传入-1，则返回原模型对应的根节点dbid</li>' +
        '<li style="list-style-type:disc">优化DracoLoader创建，提升LOD加载效率</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">修复getNodeIdByPath获取不到节点</li>' +
        '<li style="list-style-type: disc;">修复设置构件颜色后隐藏构件再显示时构件颜色不正确问题</li>' +
        '<li style="list-style-type: disc;">修复LOD数据draco压缩后边线数据错乱问题</li>' +
        '<li style="list-style-type: disc;">修复移动端黑屏问题</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.93.92',
      id: '9',
      time: '2022-02-24',
      list:
        '<div style="font-weight:bold">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">LOD支持线数据隔离</li>' +
        '<li style="list-style-type:disc">LOD支持构件动画</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">选中效果优化</li>' +
        '<li style="list-style-type:disc">优化构件动画相关接口</li>' +
        '<li style="list-style-type:disc">模型树多选功能优化，修复选择时报错</li>' +
        '<li style="list-style-type:disc">更新draco库，解决几何数据量过大时解码报错问题</li>' +
        '<li style="list-style-type:disc">优化getMergeInfo接口</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">修复通过模型树设置节点隐藏时构件选中轮廓线未消失</li>' +
        '<li style="list-style-type: disc;">修复隐藏构件线数据显示问题</li>' +
        '<li style="list-style-type: disc;">修复设置构件颜色后选中再取消后，设置构件颜色消失</li>' +
        '<li style="list-style-type: disc;">修复设置构件颜色时选中轮廓</li>' +
        '<li style="list-style-type: disc;">修复移动构件后的选中效果显示不正确</li>' +
        '<li style="list-style-type: disc;">修复二维图层面板无法收起</li>' +
        '<li style="list-style-type: disc;">修复属性搜索全选构件行为错误</li>' +
        '<li style="list-style-type: disc;">修复属性搜索找不到节点时报错</li>' +
        '<li style="list-style-type: disc;">修复y-up模型选中效果问题</li>' +
        '<li style="list-style-type: disc;">修复隐藏后选中根节点并全部显示，有些隐藏构件未选中问题</li>' +
        '<li style="list-style-type: disc;">修复getNodeIdByPath接口获取不到节点</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.89.88',
      id: '8',
      time: '2022-02-10',
      list:
        '<div style="font-weight:bold">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">构件选中效果改版</li>' +
        '<li style="list-style-type:disc">模型树面板和构件选中联动</li>' +
        '<li style="list-style-type:disc">LOD贴图数据写入indexDB缓存</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">动画功能优化</li>' +
        '<li style="list-style-type:disc">爆炸视图数据计算优化</li>' +
        '<li style="list-style-type:disc">优化通过OBVID查找NodeId接口</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">修复模型重新转换后新数据不能写入缓存的问题</li>' +
        '<li style="list-style-type: disc;">修复LOD模型树节点不能关注的问题</li>' +
        '<li style="list-style-type: disc;">修复LOD合模若模型未全部加载时工具条不能全部展示问题</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.68.65',
      id: '7',
      time: '2021-12-27',
      list:
        '<div style="font-weight:bold">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">lod支持setModelLineColor设置边线颜色，实现getMesh接口</li>' +
        '<li style="list-style-type:disc">lod适配多视图版本</li>' +
        '<li style="list-style-type:disc">实现构件剖切动画</li>' +
        '<li style="list-style-type:disc">动画支持设置颜色、闪烁等接口</li>' +
        '<li style="list-style-type:disc">相机动画和构件transform增加返回上一步的接口</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">lod写缓存兼容多视图版本</li>' +
        '<li style="list-style-type:disc">增加对贴图旋转、偏移参数的支持，解决贴图效果不正确问题</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">解决默认透视切换到正交被裁减的问题;解决部分模型正交fitToView无效的问题</li>' +
        '<li style="list-style-type: disc;">修复lod部分构件明暗关系不对的问题</li>' +
        '<li style="list-style-type: disc;">解决地图裁减问题</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.3.56.57',
      id: '6',
      time: '2021-12-07',
      list:
        '<div style="font-weight:bold">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">LOD完善设置构件颜色接口</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">属性搜索面板动作优化</li>' +
        '<li style="list-style-type:disc">threejs版本回退到129</li>' +
        '</ul>' +
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '<ul style="line-height:30px;margin-left:15px">' +
        '<li style="list-style-type:disc;margin-top:5px">修复动画构件复位部分构件报错</li>' +
        '<li style="list-style-type: disc;">修复marker 标注连线位置不对</li>' +
        '<li style="list-style-type: disc;">修复unloadModel接口导致模型树被清空</li>' +
        '<li style="list-style-type: disc;">修复批注与其他面板同时使用冲突</li>' +
        '</ul>',
    },
    {
      name: 'JavaScript SDK版本5.1.342',
      id: '5',
      time: '2021-03-09',
      list:
        '<div style="font-weight:bold">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">增加面板缩放功能</li></ul>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type: disc;">增加<a href="../../../../playground/lod/?sampleID=lightDirection" target="_blank">阴影显示</a>效果，支持设置光照方向</li></ul>' +
        '<pre style="border-left:5px solid #383838;margin:20px 0"><code>' +
        '   // 选择一个指定的日期，根据经纬度计算当天日出和日落时间以及光照方向</br>' +
        '   // 时间为2021年3月5日</br>' +
        '   let dateString = "2021-03-05T";</br>' +
        '   const timeValue = Number(time.value);</br>' +
        '   var h = Math.floor(timeValue / 3600);</br>' +
        '   var m = Math.floor((timeValue / 60) % 60);</br>' +
        '   var s = Math.floor(timeValue % 60);</br>' +
        '   if (h.toString().length === 1) {</br>' +
        '       h = "0" + h;</br>' +
        '   }</br>' +
        '   if (m.toString().length === 1) {</br>' +
        '       m = "0" + m;</br>' +
        '   }</br>' +
        '   if (s.toString().length === 1) {</br>' +
        '       s = "0" + s;</br>' +
        '   }</br>' +
        '   timeLabel.innerText = h + ":" + m + ":" + s;</br>' +
        '   dateString = dateString + h + ":" + m + ":" + s;</br>' +
        '   // 选取的经纬度为上海的经纬度（31.23,121.47）</br>' +
        '   obvApi.setSunPosition(new Date(dateString), 31.23, 121.47);' +
        '</code></pre>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type: disc;">增加<a href="../../../../playground/lod/?sampleID=modelAMap" target="_blank">地图场景</a>功能</li></ul>' +
        '<pre style="border-left:5px solid #383838;margin:20px 0"><code>' +
        '   // 创建地图需要的参数</br>' +
        '   const mapMess = {</br>' +
        '       level: 18,</br>' +
        '       position: [119.8936730134426, 31.697610020351423],</br>' +
        '       range: 5000,</br>' +
        '       mapUrl: </br>' +
        '   "https://wprd01.is.autonavi.com/appmaptile?x=[x]&y=[y]&z=[z]"</br>' +
        '   };{</br>' +
        '   // 创建AMap实例对象</br>' +
        '   map = new OBV.Utils.AMap(mapMess);</br>' +
        '   mapMeshGroup = map.createMap();</br>' +
        '   // 设置模型旋转角度</br>' +
        '   map.clockWise(mapMeshGroup, 7);</br>' +
        '   const model = obvApi.getModelBounds();{</br>' +
        '   mapMeshGroup.position.z = model.min.z + 7;</br>' +
        '   // 将创建的外部场景地图，加载到模型中进行查看</br>' +
        '   obvApi.addExternalObject("my-external", mapMeshGroup);</br>' +
        '</code></pre>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type: disc;">增加<a href="../../../../playground/lod/?sampleID=dynamicLoad" target="_blank">按需加载</a>功能</li></ul>' +
        '<pre style="border-left:5px solid #383838;margin:20px 0"><code>' +
        '   let applicationOptions = {</br>' +
        '       getAccessToken: getAccessToken,</br>' +
        '       refreshAccessToken: getAccessToken,</br>' +
        '       serviceConfig: {</br>' +
        '           origin: "https://api.cloud.pkpm.cn",</br>' +
        '           apiContextPath: "/bimserver/viewing/v3",</br>' +
        '       },</br>' +
        '       // 设置 dynamicLoad 为 true 可不显示模型，先加载模型树，再根据业务需求显示需要的构件</br>' +
        '       dynamicLoad: true,</br>' +
        '   };</br>' +
        '</code></pre>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type: disc;">增加setLimitHeight接口：设置模型超出指定高度部分的颜色</li></ul>' +
        '<pre style="border-left:5px solid #383838;margin:20px 0"><code>' +
        '   // 设置建筑超出高度部分的颜色，输入参数依次为：modelId，红色值，绿色值，蓝色值</br>' +
        '   obvApi.setLimitHeight(1, height, redValue, greenValue, blueValue);</br>' +
        '</code></pre>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type: disc;">增加getNodeIdsByBoundingBox接口：获取包围盒内部的构件nodeId</li></ul>' +
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">优化按需加载进度展示</li>' +
        '<li style="list-style-type: disc;">修复getMesh接口没有返回纹理坐标的问题</li>' +
        '<li style="list-style-type: disc;">修复选中数据中存在重复的问题</li></ul>' +
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">修复合模时构件隔离显示不正确</li>' +
        '<li style="list-style-type: disc;">修复y-up模型显示为黑色的问题</li></ul>',
    },
    {
      name: 'JavaScript SDK版本5.1.328',
      id: '4',
      time: '2021-02-08',
      list:
        '<div style="font-weight:bold">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">增加<a href="../../../../playground/lod/?sampleID=heatMap" target="_blank">热力图</a>功能</li></ul>' +
        '<pre style="border-left:5px solid #383838;margin:20px 0"><code>' +
        '   // 传入构件nodeId获取构件包围盒信息，以及想要生成热力图的方位，上"top"、下"bottom"、左"left"、右"right"、前"front"、后"back"</br>' +
        '   const pointsObject = obvApi.getPlaneVertexFromObject([{ dbId:22205, modelId: 1 }], "top");</br>' +
        '   let dataArray = createHeatMapData(20);</br>' +
        '   // 创建热力图需要的参数</br>' +
        '   const heatMap2dOptions = {</br>' +
        '       plane: pointsObject,</br>' +
        '       data: dataArray,</br>' +
        '       radius: 50,</br>' +
        '   };</br>' +
        '   // 创建HeatMap2d实例对象</br>' +
        '   heatMap2d = new OBV.Utils.HeatMap2d(heatMap2dOptions);</br>' +
        '   // 保存多个heatMap对象</br>' +
        '   heatMapList.push(heatMap2d);' +
        '   // 创建热力图2D平面对象</br>' +
        '   const heatMapMesh = heatMap2d.getHeatMapPlane();</br>' +
        '   heatMapMesh.position.z = heatMapMesh.position.z + 0.01;</br>' +
        '   // 添加到外部场景</br>' +
        '   obvApi.addExternalObject(externalSceneName, heatMapMesh);</br>' +
        '</code></pre>' +
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">增加盒剖切进度条操作,并且支持移动端</li>' +
        '<li style="list-style-type: disc;">轴网增加字体调节功能</li></ul>' +
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">修复合模时构件隔离显示不正确</li>' +
        '<li style="list-style-type: disc;">修复部分模型主视图被裁减的问题</li></ul>',
    },
    {
      name: 'JavaScript SDK版本5.1.323',
      id: '3',
      time: '2021-02-01',
      list:
        '<div style="font-weight:bold">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">优化X光下透明构件不剔除</li></ul>' +
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">修复按需加载，show接口返回时机不正确</li>' +
        '<li style="list-style-type: disc;">修复按需加载，实例化的构件处理不正确</li>' +
        '<li style="list-style-type: disc;">修复轴网，鼠标悬浮位置不正确</li></ul>',
    },
    {
      name: 'JavaScript SDK版本5.1.320',
      id: '2',
      time: '2021-01-28',
      list:
        '<div style="font-weight:bold">三维模型</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">增加可以控制聚焦构件距离的接口</li>' +
        '<li style="list-style-type: disc;">增加线选中功能</li>' +
        '<li style="list-style-type: disc;">增加获取多个坐标系的接口</li></ul>' +
        '<div style="font-weight:bold;margin-top:15px">模型加载</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">增加模型按需加载功能</li></ul>' +
        '<div style="font-weight:bold;margin-top:15px">模型优化</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">优化加载进度条</li>' +
        '<li style="list-style-type: disc;">优化轴网相关问题</li></ul>' +
        '<div style="font-weight:bold;margin-top:15px">问题修复</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">修复Label姿态问题</li>' +
        '<li style="list-style-type: disc;">修复getVisibleObjects接口报错</li></ul>',
    },
    {
      name: 'JavaScript SDK版本5.1.312',
      id: '1',
      time: '2021-01-25',
      list:
        '<div style="font-weight:bold">模型效果</div>' +
        '<ul style="line-height:30px;margin-left:15px"><li style="list-style-type:disc;margin-top:5px">修复部分模型颜色显示过亮的问题</li></ul>',
    },
  ],
}
export { Data }



// WEBPACK FOOTER //
// ./src/pages/devCenter/updateLogs/dataLogDetail.js